import * as React from 'react';
import classnames from 'classnames';
import { Hr } from '@grandvisionhq/elements';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { useProductDetailSlots } from '../../../slots/context.js';
import '@grandvisionhq/state';
import '../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../operations/queries/get-accessories-by-slug.js';
import '../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../operations/queries/get-frames-by-slug.js';
import '../../../operations/queries/get-solutions-by-slug.js';
import '../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '../../../types/product.js';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import { ProductTag } from '../components/ProductTag/ProductTag.js';
import { PurchaseTypeSelectionBoxesContainer } from '../components/PurchaseTypeSelectionBoxes/PurchaseTypeSelectionBoxesContainer.js';
import { VariantSelectorTree } from '../components/VariantSelectorTree/VariantSelectorTree.js';
import '@grandvisionhq/lib-cookies';
import { PriceSectionContainer } from '../components/PriceSection/PriceSectionContainer.js';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { SolutionsCTA } from './components/SolutionsCTA/SolutionsCTA.js';
import { SolutionsDeliveryIndicator } from './components/SolutionsDeliveryIndicator/SolutionsDeliveryIndicator.js';
import { SolutionsDeliveryIntervalSelect } from './components/SolutionsDeliveryIntervalSelect/SolutionsDeliveryIntervalSelect.js';
import { SolutionsQuantityAndStock } from './components/SolutionsQuantityAndStock/SolutionsQuantityAndStock.js';

const SolutionsEcommContent = ({ className , ctaRef  })=>{
    const { activeVariant: { displayName  } ,  } = useProductData();
    const { Slots  } = useProductDetailSlots();
    return /*#__PURE__*/ React.createElement("section", {
        "aria-label": displayName,
        className: classnames('solutions-ecomm-content', className)
    }, /*#__PURE__*/ React.createElement(ProductTag, {
        className: "solutions-ecomm-content__tag"
    }), /*#__PURE__*/ React.createElement(PriceSectionContainer, null), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement(VariantSelectorTree, null), /*#__PURE__*/ React.createElement("div", {
        className: "solutions-ecomm-content__column"
    }, /*#__PURE__*/ React.createElement(PurchaseTypeSelectionBoxesContainer, null), /*#__PURE__*/ React.createElement(SolutionsDeliveryIntervalSelect, null), /*#__PURE__*/ React.createElement(SolutionsQuantityAndStock, null), /*#__PURE__*/ React.createElement(SolutionsDeliveryIndicator, null), /*#__PURE__*/ React.createElement("div", {
        ref: ctaRef
    }, /*#__PURE__*/ React.createElement(SolutionsCTA, null)), Slots.AfterCTA && /*#__PURE__*/ React.createElement(Slots.AfterCTA, null)));
};

export { SolutionsEcommContent };
//# sourceMappingURL=SolutionsEcommContent.js.map
